module.exports = __webpack_public_path__ + "static/media/i_want.25975eeb.jpeg";